export const simulationStatusValues = {
    NOT_SIMULATED: 'not-simulated',
    READY_TO_CONFIRM: 'ready-to-confirm',
    READY_TO_REJECT: 'ready-to-reject',
    CONFIRMED: 'confirmed',
};

export const simulationStatusText = {
    NOT_SIMULATED: 'Not yet approved for deployment',
    READY_TO_CONFIRM: 'Approve for deployment',
    READY_TO_REJECT: 'Reject deployment ?',
    CONFIRM_BUTTON: 'Approve',
    CONFIRMING_BUTTON: 'Approving...',
    REJECT_BUTTON: 'Reject',
    REJECTING_BUTTON: 'Rejecting...',
    CONFIRMED: 'Approved for deployment',
};

export const isFileSimulated = (file) => Boolean(file?.is_simulated);

export const deriveSimulationStatus = ({ file, hasSimulationResponse }) => {
    if (isFileSimulated(file)) {
        if (hasSimulationResponse) {
            return simulationStatusValues.READY_TO_REJECT;
        }

        return simulationStatusValues.CONFIRMED;
    }

    if (hasSimulationResponse) {
        return simulationStatusValues.READY_TO_CONFIRM;
    }

    return simulationStatusValues.NOT_SIMULATED;
};

export const shouldResetReadyToConfirmByProfileChange = ({
    previousProfileId,
    currentProfileId,
    file,
    hasSimulationResponse,
    resetOnProfileChange = false,
}) => {
    if (!resetOnProfileChange) {
        return false;
    }

    if (!hasSimulationResponse) {
        return false;
    }

    return (previousProfileId || null) !== (currentProfileId || null);
};
